import { axios as request } from "../../request/http";

const interfaceUrl = {
  "api_shopInfoAdd": `/shop/spInfo/add`, // post 添加资金商&服务商管理
  "api_shopInfoDel": `/shop/spInfo/delete`, // post 删除资金商&服务商管理
  "api_shopInfoQuery": "/shop/spInfo/query", // get 查询资金商&服务商管理
  "api_shopInfoQueryAll": "/shop/spInfo/queryAll", // get 查询资金商&服务商管理
  "api_shopInfoQueryList": "/shop/spInfo/queryList", // post 查询资金商&服务商管理
  "api_shopInfoUpdate": "/shop/spInfo/update", // post 更新资金商&服务商管理
  "api_shopInfoupdateArea": "/shop/spArea/updateArea", // 设置覆盖区域
  "api_shopInfoGetArea": "/shop/spArea/queryList", // 查询覆盖区域
  "api_shopInfoGetAreaTree": "/shop/spArea/queryBySpCode" //查询覆盖区域-Tree

}

// initial state
const state = {
  shopInfo: {},
  shopInfoList: [],
  shopInfoAll: [],
  spAreaList: [],
  spAreaMap: {},
  spInfoQueryAll: []
}

// getters
const getters = {
  getShopInfoQuery: state => {
    return state.shopInfo
  },
  getShopInfoQueryAll: state => {
    return state.shopInfoAll
  },
  getShopInfoQueryList: state => {
    return state.shopInfoList
  },
  getSpAreaList: state => {
    return state.spAreaList
  },
  getSpAreaMap: state => {
    return state.spAreaMap
  },
  getSpInfoQueryAll: state => {
    return state.spInfoQueryAll
  },
}

// actions
const actions = {
  shopInfoAdd: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoAdd,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  shopInfoDel: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoDel,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  shopInfoQuery: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoQuery,
      method: "GET",
      params: params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOPINFO_QUERY', res.data || {});
      } else {
        commit('SHOPINFO_QUERY', {});
      }
    }).catch(err => {
      commit('SHOPINFO_QUERY', {});
    })
  },
  shopInfoQueryAll: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoQuery,
      method: "GET",
      params: params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOPINFO_QUERY', res.data || {});
      } else {
        commit('SHOPINFO_QUERY', {});
      }
    }).catch(err => {
      commit('SHOPINFO_QUERY', {});
    })
  },
  getSpInfoQueryAll: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoQueryAll,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SP_INFO_QUERY_ALL', res.data || []);
      } else {
        commit('SP_INFO_QUERY_ALL', []);
      }
    }).catch(err => {
      commit('SP_INFO_QUERY_ALL', []);
    })
  },
  shopInfoQueryList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoQueryList,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOPINFO_QUERY_LIST', res || {});
      } else {
        commit('SHOPINFO_QUERY_LIST', {});
      }
    }).catch(err => {
      commit('SHOPINFO_QUERY_LIST', {});
    })
  },
  shopInfoUpdate: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoUpdate,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  shopInfoUpdateArea: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoupdateArea,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  getSpAreaList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoGetArea,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SP_AREA_QUERY_LIST', res || {});
      } else {
        commit('SP_AREA_QUERY_LIST', {});
      }
    }).catch(err => {
      commit('SP_AREA_QUERY_LIST', {});
    })
  },
  getSpAreaMap: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoGetAreaTree,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SP_AREA_QUERY_MAP', res.data || {});
      } else {
        commit('SP_AREA_QUERY_MAP', {});
      }
    }).catch(err => {
      commit('SP_AREA_QUERY_MAP', {});
    })
  },
}

// mutations
const mutations = {
  SHOPINFO_QUERY: (state, pageData) => {
    state.shopInfo = pageData;
  },
  SHOPINFO_QUERY_LIST: (state, pageData) => {
    state.shopInfoList = pageData;
  },
  SP_AREA_QUERY_LIST: (state, pageData) => {
    state.spAreaList = pageData;
  },
  SP_AREA_QUERY_MAP: (state, pageData) => {
    state.spAreaMap = pageData;
  },
  SP_INFO_QUERY_ALL: (state, pageData) => {
    state.spInfoQueryAll = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant.js